<div class="">
  <div class="top-bar-categories flex align-items-center">
    <div class="flex align-items-center m-1">
      <i class="fas fa-history me-3"></i>
      <h5 class="m-0">Documentos</h5>
    </div>
  </div>
  <div class="p-1">
    <p-table
      [first]="first"
      [value]="orders"
      [paginator]="true"
      (onLazyLoad)="fetchOrders($event)"
      [rows]="rows"
      [loading]="loading"
      [lazy]="true"
      [totalRecords]="totalRows"
      currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords} registros"
      [rowsPerPageOptions]="[10, 25, 50]"
      styleClass="p-datatable-striped p-datatable-sm"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="text-center">OV</th>
          @if (isEnterprise) {
          <th class="text-center">OC</th>
          } @if (isB2b) {
          <th class="text-center">CC</th>
          }
          <th class="text-center">DTE</th>
          <th class="text-center">FECHA</th>
          <th class="text-center">TOTAL</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-order>
        <tr>
          <td class="text-center">
            <a
              routerLink="/carro-compra/downloadpdf"
              [queryParams]="{ numero: order.salesId }"
              target="_blank"
              >{{ order.salesId }}</a
            >
          </td>
          @if (isEnterprise) {
          <td class="text-center">
            @if (order?.idShoppingCart) {
            <a
              target="_blank"
              class="dropdown-item"
              routerLink="/carro-compra/downloadpdf"
              [queryParams]="{
                numero: order?.idShoppingCart,
                tipo: 'orden-compra'
              }"
            >
              Ver OC
            </a>
            } @if (order.oc) {
            {{ order.oc.slice(0, 15) }}
            }
          </td>
          } @if (isB2b) {
          <td class="text-center">
            @if (order?.costCenter) {
            {{ order?.costCenter }}
            } @if (!order?.costCenter) {
            <font color="red"> S/CC</font>
            }
          </td>
          }
          <td class="text-center">
            @if (order.invoice) {
            <a
              routerLink="/carro-compra/downloadpdf"
              [queryParams]="{
                numero: order.invoice.number,
                tipo: 'factura',
                tipo_doc: order.observation
              }"
              target="_blank"
              >{{ order.invoice.number }}</a
            >
            } @if (!order.invoice) { NN }
          </td>
          <td class="text-center">
            {{ order.timestamps.creationDate | date : 'dd-MM-yy' }}
          </td>
          <td class="text-center">{{ order.payment.amount | currency }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
